<template>
    <div>

        <rkm-area
            title="Transferências enviadas"
            no-margin-top
        >

            <rkm-table
                :fields="fields.tables.tipo"
                :items="dados"
                :filter="filter"
                ref="Table"
                class="mt-3"
            >
                <template slot="filters">
                    <rkm-row>
                        <rkm-col class="flex-grow-1">
                            <rkm-form-input
                                placeholder="Digite para buscar"
                                v-model="filter"
                            >
                                <rkm-input-group-prepend slot="prepend">
                                    <rkm-input-group-text>Buscar</rkm-input-group-text>
                                </rkm-input-group-prepend>
                            </rkm-form-input>
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.anos"
                                show-default-option
                                default-option-text="Selecione o ano"
                                text-field="cotaAno"
                                v-model="model.cotaAno"
                            />
                        </rkm-col>

                        <rkm-col cols="2">
                            <rkm-form-select
                                :options="data.form.meses"
                                show-default-option
                                default-option-text="Selecione o mês"
                                text-field="descricao"
                                value-field="id"
                                v-model="model.cotaMes"
                            />
                        </rkm-col>

                        <rkm-col class="flex-grow-0">
                            <rkm-button
                                :disabled="!filter && !model.cotaMes && !model.cotaAno"
                                @click="handleClearFilter"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:cell(cota)="row" >
                    <span>{{ getCotaExame(row.item) }}</span>
                </template>

                <template v-slot:cell(origemInicio)="row">
                    <span>{{ row.item.origemInicio }} - {{ row.item.origemFim }}</span>
                </template>

                <template v-slot:cell(destinoInicio)="row">
                    <span>{{ row.item.destinoInicio }} - {{ row.item.destinoFim }}</span>
                </template>

                <template v-slot:cell(actions)="{ index, item }">

                    <rkm-button
                        v-if="transferenciaLaboratorio"
                        @click="$refs.Modal.open(item)"
                        class="colorButton"
                        small
                        title="Detalhamento"
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>

                    <rkm-button
                        @click.stop="$emit('handleAlter', index, item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>

                    <rkm-button
                        color="danger"
                        title="Excluir"
                        small
                        @click.stop="handleDestroy(item)"
                    >
                        <rkm-icon icon="trash" />
                    </rkm-button>

                </template>
            </rkm-table>
        </rkm-area>

        <Modal
            :data="data"
            :laboratorioUnidadeId="laboratorioUnidadeId"
            :laboratorioInfraestruturaId="laboratorioInfraestruturaId"
            :unidadeId="unidadeId"
            :infraestruturaId="infraestruturaId"
            ref="Modal"
        />

    </div>
</template>

<script>
// Mixins.
import { data, formats } from '@/mixins'

// Moment.
import moment from 'moment'

// Components.
import Modal from './Modal'

// Enums.
import tipoCota from '@/enums/exame-laboratorial/tipoCota'
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

export default {
    components: { Modal },
    computed: {
        fields() {

            return {
                tables: {
                    tipo: [
                        {
                            key: 'destinoNomeFantasia',
                            label: 'Unidade destino',
                            sortable: true
                        },
                        {
                            key: 'destinoInfraestruturaNome',
                            label: 'Local de atendimento',
                            sortable: true
                        },
                        {
                            key: 'origemCotaTipoNome',
                            label: 'Tipo',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min',
                        },
                    ],
                    transferencia: [
                        {
                            key: 'origemUnidadeId',
                            label: 'Unidade origem',
                            sortable: true
                        },
                        {
                            key: 'origemCotaTipoNome',
                            label: 'Tipo',
                            sortable: true
                        },
                        {
                            key: 'cota',
                            label: 'Cota',
                            sortable: true
                        },
                        {
                            key: 'origemInicio',
                            label: 'Período origem',
                            sortable: true
                        },
                        {
                            key: 'destinoInicio',
                            label: 'Período destino',
                            sortable: true
                        },
                        {
                            key: 'actions',
                            label: 'Ações',
                            class: 'col-min',
                        },
                    ],
                }
            }
        },
        dados(){

            const ano = this.model.cotaAno
            const mes = this.model.cotaMes

            if (ano != null && mes != null) {

                return this.cotaUnidadeSolicitante.filter(i => {return i.origemInicio.substr(6, 4) == ano
                    && i.origemInicio.substr(3, 2) == mes})

            } else if ( ano != null) {

                return this.cotaUnidadeSolicitante.filter(i => {return i.origemInicio.substr(6, 4) == ano})

            } else if ( mes != null) {

                return this.cotaUnidadeSolicitante.filter(i => {return i.origemInicio.substr(3, 2) == mes})
            }

            return this.cotaUnidadeSolicitante
        },
    },
    data: () => ({
        items: [],
        recebidos: [],
         model:{
            cotaAno: null,
            cotaMes: null,
        },
        filter: null,
        enums: {
            tipoCota,
            tipoUnidade,
        },
    }),
    created() {

        this.load()
    },
    methods: {
        load() {

            this.model.cotaAno = moment().format("YYYY")
        },
        handleDestroy(item) {

            const objIndex = this.cotaUnidadeSolicitante.findIndex((obj => obj.id == item.id));

            const destroy = async () => {
                this.cotaUnidadeSolicitante.splice(objIndex, 1)
            }

            this.showDeleteConfirmation(`Deseja realmente excluir a transferência?`, destroy)
        },
        handleClearFilter() {
            this.filter = null
            this.model.cotaMes = null
            this.model.cotaAno = null
        },
        getCotaExame(item) {

            let cotaExame = 0

            if (item.origemCotaTipoId == this.enums.tipoCota.VALOR) {

                 cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + this.formatSumMoney(element.transferido);
                    }

                    return sum;
                },0)

                if (cotaExame) {

                    cotaExame = this.formatMoney(cotaExame, 2)

                    let destinoCotaValor = this.formatMoney(item.destinoCotaValor, 2)
                    let cotaTotal = this.formatSumMoney(destinoCotaValor) + this.formatSumMoney(cotaExame)

                    return this.formatMoney(cotaTotal, 2)

                } else {

                    return this.formatMoney(item.destinoCotaValor, 2)
                }
            } else {

                cotaExame = item.exames.reduce((sum, element) => {

                    if (element.transferido) {
                        sum = sum + Number(element.transferido);
                    }

                    return sum;
                },0)

                return this.formatMoney(Number(item.destinoCotaQuantidade) + cotaExame, 0)
            }
        }
    },
    mixins: [data, formats],
    props: {
        unidadeId: { type: Number, default: null },
        infraestruturaId: { type: Number, default: null },
        laboratorioUnidadeId: { type: Number, default: null },
        laboratorioInfraestruturaId: { type: Number, default: null },
        data: { type: Object, required: true },
        cotaUnidadeSolicitante: { type: Array, required: true },
        transferenciaLaboratorio: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.colorButton {
    color: #fff;
}
</style>